import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchProgramsArgs,
  FetchProgramById,
} from '../api/types/programs.types';

import { fetchProgramById, fetchPrograms } from '../api/programs.api';

export const programsQueryKeys = createQueryKeys('programs', {
  fetchInfinitePrograms: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchProgramsArgs) => ({
    queryFn: async (context: any) =>
      fetchPrograms({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchProgramById: ({ id, locale, organizationId }: FetchProgramById) => ({
    queryFn: () => fetchProgramById({ id, locale, organizationId }),
    // No need to put locale in the queryKey, since exercise is returned with all translations, this includes tags too.
    queryKey: [organizationId, id],
  }),
  fetchPrograms: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchProgramsArgs) => ({
    queryFn: () =>
      fetchPrograms({
        contentFilters,
        locale,
        organizationId,
        tableFilters,
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
});
